export default __webpack_public_path__ + "static/media/aws_brand_logo.f3974665.svg";